import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './csnotes.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {baseUrl} from '../../config';
import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";
function Cssnotes() {
    console.log('Cssnotes')
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const [loader,setLoader]=useState(false)
    const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
checkUserTypeFn(history);

function checkUserTypeFn(history){
const userdata=JSON.parse(localStorage.getItem('userdata'));
const usertype=userdata.type;
console.log('in check usertype fn');
console.log(usertype)
if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
  history.push('/');
}

}
  
    const handleSignOut = () => {
        console.log('logout')
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
    
      if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
        history.push('/');
      }
    const [cssCodesData,setcssCodesData]=useState([])
    const [resultCount,setResultCount]=useState(0);
    const [resultCountCounter,setResultCountCounter]=useState(0);
  
    const [message, setMessage] = useState('')
    const [successMsg,setSuccessMsg]=useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];

    useEffect(() => {
      setLoader(true)
      axiosIntance.get(baseUrl+'/count/csnotes', {}).then(response => {
        console.log('resultCount='+response.data.result);
        setResultCount(response.data.result);
        setResultCountCounter(1);
        setLoader(false)
      }).catch(error => {
        console.log(error)
        setMessage('Something went wrong');
      });
  
  
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])

      const SubmitDelete = (e) => {

        confirmAlert({
          title: '',
          message: 'Are you sure want to delete All data',
          buttons: [
            {
              label: 'Yes',
              onClick: () => 
              axiosIntance.delete(baseUrl+'/csnotes', {}).then(response => {
                setSuccessMsg('Deleted!')
              }).catch(error => {
                setMessage('Something went wrong');
              })
    
            },
            {
              label: 'No',
              onClick: () => console.log('No')
            }
          ]
        });
      }
    return (
        <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


    <div className='delete-div'>
      {
            resultCount>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>


      <section id="content-wrapper">

      {loader &&
    <div className='loaderDiv'>  
        <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
              //timeout={1000} //3 secs
          />
    </div> 
    }

      {resultCountCounter>0 && 
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}
          columns={[
            // { title: "Note Id", field: "id" },
            { title: "Note Time", field: "note_time" },
            { title: "Note left", field: "note_left" },
            { title: "Note Contents", field: "note_contents" },
            { title: "Order Id", field: "order_id" },
          
            { title: "Created By", field: "created_by" },
           
           
          ]}
          data={query =>
            new Promise((resolve, reject) => {
              // console.log(query)
           
              let url = baseUrl+'/csnotes?'
              url += `&_page=${query.page + 1}`
              url += `&_limit=${query.pageSize}`
              fetchInstance(url)
                .then(response => response.json())
                .then(result => {
                  
                 
                  resolve({
                    data: result.result,
                    page: query.page,
                    totalCount: resultCount,
                  })
                })
            })
          }
        
          options={{
            sorting: false,
            search: false,
            loadingType: 'overlay',
            // headerStyle: { fontSize:'15px',fontWeight:'bold' },
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
          title="CS Notes Data"
        />
      }
      </section>
    </div>
    )
}

export default Cssnotes
